/**
 * ═══════════════════════════════════════════════════════════════════════
 * SCROLL ANIMATIONS ENGINE (Intersection Observer)
 * ═══════════════════════════════════════════════════════════════════════
 */

export default function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('[data-animate]');

  // Respect reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    animatedElements.forEach(el => el.classList.add('is-animated'));
    return;
  }

  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = el.getAttribute('data-delay') || 0;

        setTimeout(() => {
          el.classList.add('is-animated');
        }, delay);

        // Stop observing once animated
        observer.unobserve(el);
      }
    });
  }, observerOptions);

  animatedElements.forEach(el => observer.observe(el));
}
